import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ChartLineUp, Calculator, Coins, Newspaper, Watch, Sparkle } from "@phosphor-icons/react";
import SymbolSearch from "./SymbolSearch";

export default function Header({ ts }) {
  const time = ts ? new Date(ts * 1000).toLocaleTimeString() : "--";
  const navigate = useNavigate();
  const loc = useLocation();
  const goto = (sym) => navigate(`/asset/${encodeURIComponent(sym)}`);

  const NavBtn = ({ to, label, icon: Icon, testid }) => {
    const active = loc.pathname === to;
    return (
      <button
        onClick={() => navigate(to)}
        className={`flex items-center gap-1.5 px-2.5 py-1.5 mono text-[10px] uppercase tracking-[0.16em] border transition-colors duration-150 ${
          active
            ? "bg-white text-black border-white"
            : "bg-transparent text-white/60 border-white/10 hover:border-white/40 hover:text-white"
        }`}
        data-testid={testid}
      >
        <Icon size={12} weight="bold" />
        <span className="hidden md:inline">{label}</span>
      </button>
    );
  };

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-black/70 border-b border-white/10 px-4 md:px-6 h-14 flex items-center justify-between gap-4"
      data-testid="app-header"
    >
      <div className="flex items-center gap-3 shrink-0">
        <button
          onClick={() => navigate("/")}
          className="w-8 h-8 bg-white text-black flex items-center justify-center hover:bg-white/90 transition-colors duration-150"
          title="Dashboard"
          data-testid="brand-home"
        >
          <ChartLineUp size={18} weight="bold" />
        </button>
        <div className="hidden sm:block">
          <div className="heading text-sm font-bold tracking-tight leading-none" data-testid="brand-name">SENT-I-METER</div>
          <div className="overline mt-0.5 leading-none">global market sentiment</div>
        </div>
      </div>

      <div className="flex-1 max-w-md hidden md:block">
        <SymbolSearch
          onAdd={goto}
          onSelect={goto}
          placeholder="Search any ticker globally..."
          testid="header-search"
        />
      </div>

      <div className="flex items-center gap-2 shrink-0">
        <NavBtn to="/insights" label="Insights" icon={Sparkle} testid="nav-insights" />
        <NavBtn to="/news" label="News" icon={Newspaper} testid="nav-news" />
        <NavBtn to="/watches" label="Watches" icon={Watch} testid="nav-watches" />
        <NavBtn to="/sip" label="SIP" icon={Calculator} testid="nav-sip" />
        <NavBtn to="/funds" label="Funds" icon={Coins} testid="nav-funds" />
        <div className="hidden lg:flex items-center gap-2 ml-2">
          <span className="w-2 h-2 bg-bullish rounded-full live-dot" />
          <span className="overline">live</span>
        </div>
        <div className="mono text-xs text-white/60 hidden sm:block" data-testid="header-time">{time}</div>
      </div>
    </header>
  );
}
